import { faCalendarDays as a, faPaperclip as l, faLock as o, faCircleExclamation as r, faBullhorn as c } from "@fortawesome/pro-solid-svg-icons";
const n = {
  bullhorn: c,
  exclamation: r,
  lock: o,
  paperclip: l,
  calendar: a
};
export {
  n as helperIconOptions
};
